import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';
import ApolloClient from 'apollo-client';

import auth from './auth';
import network from './network';
import venue from './venue';

const client = new ApolloClient();

export default combineReducers({
  routing,
  auth,
  network,
  venue,
  apollo: client.reducer(),
});



// WEBPACK FOOTER //
// ./src/reducers/index.js